import type { TextData } from "cmw-client";
import { deltaText } from "./rich-text-ops";

export const countWords = (value: string) => {
  const trimmed = value.trim();
  return trimmed === "" ? 0 : trimmed.split(/\s+/).length;
};

/**
 * The same count for a stored rich-text document, so a caller that only holds the `TextData` —
 * a form value, a saved profile — doesn't have to reach into `RichTextEditor` for the number it
 * already tracks internally. Formatting is irrelevant: the words are the `insert` strings.
 */
export const wordsInTextData = (value: TextData | null | undefined): number => countWords(deltaText(value));
